module.exports = __webpack_public_path__ + "static/media/16UNODC11.a9aaa72e.jpg";